// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"7188e799","120":"652e41e6","395":"edff0561","444":"599dc98e","453":"6b658c56"}[chunkId] + ".chunk.js";
};